import { runtimeFlag } from '@/config/runtime';

/**
 * Build-time feature flags. `VITE_*` values are inlined by Vite at build, so
 * flipping one means rebuilding the image (Dockerfile ENV), not restarting it.
 *
 * Every flag is off unless the variable is exactly the string "true".
 */

/**
 * Billing area: the "Credit Topup" and "Langganan" sidebar entries, the
 * /credit/* and /subscription/* routes, the "view subscription" / "top up"
 * links in banners and error toasts, and the matching onboarding tour steps.
 * When off, those routes redirect to /dashboard. Components and hooks stay in
 * the repo so the feature can come back with a single variable change.
 */
export const BILLING_ENABLED = import.meta.env.VITE_BILLING_ENABLED === 'true';

/**
 * CCN (CUBEforall) workspace: the /ccn/* routes and the CUBE redirect
 * callback. CCN users are routed there after SSO; when off the routes send
 * everyone to /auth. The CUBE SSO button on the login page is independent
 * of this flag (it only needs VITE_CUBE_SERVICE_ID / VITE_CUBE_CLIENT_ID).
 */
export const CCN_ENABLED = runtimeFlag('VITE_CCN_ENABLED');
